import api from "../utils/APIs/axios";
export const newOperationId = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
};
export async function basketGet(path, filters = {}) {
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, v]) => v !== "" && v != null),
  );
  return (await api(`baskets/${path}`, "GET", {}, { params })).data;
}
export async function basketPost(path, body) {
  return (await api(`baskets/${path}`, "POST", body)).data;
}
export async function basketExport(kind, filters, format) {
  const response = await api(
    `baskets/reports/${kind}`,
    "GET",
    {},
    { responseType: "blob", params: { ...filters, format } },
  );
  const url = URL.createObjectURL(response.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `baskets-${kind}.${format}`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export const errorMessage = (error) =>
  error.response?.data?.message ||
  error.message ||
  "Unable to save. Retry with the same request.";
